import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import './footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import Mapa from '../../sections/Mapa/Mapa';
import Input from '../../elements/inputs/Input';
import Button from '../../elements/buttons/Button';
import { COTIZACION_FORM } from '../../../constants/forms/cotizacion';
import { cotizacionSchema } from '../../../models/forms/cotizacionSchema';
import useForm from '../../../hooks/UseForm';
import { setErrorFormSimpleUtil } from '../../../utilities/forms/errors';
import ImgTitle from '../ImgTitle/ImgTitle';
import { apiGet } from '../../../api/api';
import Textarea from '../../elements/inputs/Textarea';

const Footer = () => {
  const [isClient, setIsClient] = useState(false);
  const [loading, setLoading] = useState(false);
  const [footer, setFooter] = useState([]);

  useEffect(() => {
    apiGet('/footers')
      .then(res => {
        const allfooter = res.flatMap(item => {
          return item;
        });
        setFooter(allfooter);
      })
      .catch(err => {
        console.error('❌ Error al obtener características:', err);
      });
  }, []);

  const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    isValid,
    resetForm,
  } = useForm(COTIZACION_FORM, cotizacionSchema);

  const iconMap = {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaTiktok
  };

  const iconComponents = {
    FaMapMarkerAlt: FaMapMarkerAlt,
    FaPhoneAlt: FaPhoneAlt,
    FaEnvelope: FaEnvelope,
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  const currentYear = new Date().getFullYear();
  const bottomText = footer[0]?.footerCopy?.textoCopy.replace('{{year}}', currentYear);

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/sendmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      const result = await response.json();

      if (response.ok) {
        resetForm();
        await Swal.fire({
          icon: "success",
          title: footer[0]?.alertas?.alertaSuccess?.titulo,
          text: footer[0]?.alertas?.alertaSuccess?.texto,
          confirmButtonColor: footer[0]?.alertas?.alertaSuccess?.colorBoton,
          confirmButtonText: footer[0]?.alertas?.alertaSuccess?.textoBoton,
        }).then(() => {
          setLoading(false);
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: footer[0]?.alertas?.alertaError?.titulo,
          text: result.message || footer[0]?.alertas?.alertaError?.texto,
          confirmButtonColor: footer[0]?.alertas?.alertaError?.colorBoton,
          confirmButtonText: footer[0]?.alertas?.alertaError?.textoBoton,
        }).then(() => {
          setLoading(false);
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos conectar con el servidor.",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      }).then(() => {
        setLoading(false);
      });
    }
  };

  return (
    <footer className="footer container-fluid">
      <ImgTitle
        desktopImage={strapiBase + footer[0]?.imgBannerEscritorio?.url}
        mobileImage={strapiBase + footer[0]?.imgBannerMobile?.url}
      />
      <div id='footer-quality-seal' className="footer-content row">
        <div className="footer-form col-md-4">
          <h3 dangerouslySetInnerHTML={{ __html: footer[0]?.footerCotizacion?.tituloPrincipal }}></h3>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              placeholder={footer[0]?.footerCotizacion?.footerCotizacionData[0]?.formText}
              variant="Simple"
              value={values.name}
              onChange={handleChange('name')}
              onBlur={handleBlur('name')}
              error={setErrorFormSimpleUtil(errors, touched, 'name')}
              success={!setErrorFormSimpleUtil(errors, touched, 'name')}
            />

            <Input
              placeholder={footer[0]?.footerCotizacion?.footerCotizacionData[1]?.formText}
              variant="Simple"
              value={values.email}
              onChange={handleChange('email')}
              onBlur={handleBlur('email')}
              error={setErrorFormSimpleUtil(errors, touched, 'email')}
              success={!setErrorFormSimpleUtil(errors, touched, 'email')}
            />

            <Input
              placeholder={footer[0]?.footerCotizacion?.footerCotizacionData[2]?.formText}
              variant="Simple"
              value={values.phone}
              onChange={handleChange('phone')}
              onBlur={handleBlur('phone')}
              error={setErrorFormSimpleUtil(errors, touched, 'phone')}
              success={!setErrorFormSimpleUtil(errors, touched, 'phone')}
            />

            {/*             <Input
              placeholder={footer[0]?.footerCotizacion?.footerCotizacionData[3]?.formText}
              variant="Simple"
              value={values.message}
              onChange={handleChange('message')}
              onBlur={handleBlur('message')}
              error={setErrorFormSimpleUtil(errors, touched, 'message')}
              success={!setErrorFormSimpleUtil(errors, touched, 'message')}
            /> */}
            <Textarea
              placeholder={footer[0]?.footerCotizacion?.footerCotizacionData[3]?.formText}
              variant="Simple"
              value={values.message}
              onChange={handleChange('message')}
              onBlur={handleBlur('message')}
              error={setErrorFormSimpleUtil(errors, touched, 'message')}
              success={!setErrorFormSimpleUtil(errors, touched, 'message')}
              rows={6}
              maxLength={1200}
            />
            <Button
              text={loading ? "Enviando..." : footer[0]?.footerCotizacion?.botonTexto}
              action={() => handleSubmit(values)}
              disabled={!isValid || loading}
            />
          </div>
        </div>
        <div className="footer-left col-md-4">
          <div className='row'>
            <div className='col-12'>
              <div className="footer-contact-container">
                <h3>{footer[0]?.footerContacto?.titulo}</h3>
                {footer[0]?.footerContacto?.footerContactoData.map((detail, index) => {
                  const IconComponent = iconComponents[detail.iconoNombre];
                  return (
                    <div key={index} className="contact-detail">
                      <div className="icon">{IconComponent && <IconComponent />}</div>
                      <span>{detail.titulo}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <div className="footer-socials">
                <h3 dangerouslySetInnerHTML={{ __html: footer[0]?.footerContacto?.tituloRedesSociales }}></h3>
                <div className='content-footer-socials'>
                  {footer[0]?.footerContacto?.redesSociales.map((social, index) => {
                    const Icon = iconMap[social.icono];
                    return (
                      <a key={index} href={social.link} target='_blank' rel="noreferrer" className={`icon ${social.plataforma}`}>
                        {Icon && <Icon />}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-contact col-md-4">
          <h3>{footer[0]?.footerVisitanosComponent?.titulo}</h3>
          <Mapa />
        </div>
      </div>
      <div className="footer-bottom">
        <span>{bottomText}</span>
      </div>
    </footer>
  );
};

export default Footer;
